import { FormWithRedux } from '../../FormWithRedux';

export class ACCBISTCTBrainForm extends FormWithRedux {

    constructor(parent, actionUpdater, dependentValuesUpdater, calculationsUpdater) {
        super('ctBrainSubform', parent, actionUpdater, dependentValuesUpdater, calculationsUpdater);
    }

    shouldDisplayFormDetailForIdentifier(identifier) {
        super.shouldDisplayFormDetailForIdentifier(identifier);
        return true;
    }

    isEnabled() {
        return true;
    }

    isMandatory(identifier) {
        if (identifier == 'ctScanFindings') {
            return false;
        }
        else if (identifier == 'isCTScanNormal') {
            return this.getValue('hasCTBeenPerformed') == true;
        }
        
        return true;
    }

    getValueType(identifier) {
        if (identifier == 'isCTScanNormal' || identifier == 'hasCTBeenPerformed') {
            return 'boolean';
        }
        else if (identifier == 'ctScanFindings') {
            return 'string';
        }

        return null;
    }

    submissionValidation() {
        return [];
    }

    editingValidation(identifier) {
        return [];
    }
}


// WEBPACK FOOTER //
// ./src/forms/concussion01/Forms/ACCBIST-CTBrainForm.js